import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import CloseIcon from '../icons/CloseIcon.jsx';
import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { isValidEmail } from '@pok/utils';
import { Trans, useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { useLoading } from '@pok/weblib/context/loading-context.jsx';
import { forgotPassword } from '../../interact.jsx';

export default function ForgotPasswordDialog({ id, onClose }) {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [step, setStep] = useState(0);
    const { showLoading, hideLoading } = useLoading();
    const handleEmail = () => {
        showLoading();
        forgotPassword(id, email).finally(() => {
            setStep(1);
            hideLoading();
        });
    };
    return (
        <>
            <Dialog
                open={true}
                onClose={onClose}
                sx={{
                    '& .MuiPaper-root': {
                        padding: 4,
                        borderRadius: '16px',
                    },
                }}
            >
                <DialogTitle>
                    <Typography component="span" variant="h3">
                        {t(`certificate.forgot_password_dialog.title${step === 1 ? '_1' : ''}`)}
                    </Typography>
                    <a onClick={onClose} style={{ position: 'absolute', right: 12, top: 12, cursor: 'pointer' }}>
                        <CloseIcon />
                    </a>
                </DialogTitle>
                <DialogContent>
                    <Stack spacing={2} pb={1}>
                        <Typography pb={2} variant="body2">
                            <Trans
                                i18nKey={`certificate.forgot_password_dialog.subtitle${step === 1 ? '_1' : ''}`}
                                values={{ email: email }}
                            />
                        </Typography>
                        {step === 0 && (
                            <TextField
                                label={t('certificate.forgot_password_dialog.enter_email')}
                                value={email}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && isValidEmail(email)) handleEmail();
                                }}
                                type="email"
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        )}
                    </Stack>
                </DialogContent>
                {step === 0 && (
                    <DialogActions sx={{ alignSelf: 'center', mt: 1 }}>
                        <Button
                            sx={{ px: 2 }}
                            variant="contained"
                            onClick={handleEmail}
                            disabled={!isValidEmail(email)}
                        >
                            {t('certificate.forgot_password_dialog.confirm')}
                        </Button>
                    </DialogActions>
                )}
            </Dialog>
        </>
    );
}
